module.exports = __webpack_public_path__ + "img/rem8.214913a6.jpg";